import {IApplicationDetails, IDocument} from "../../../modules/ninVerification/types";

export const PersonOnboardingWorkflowConstants = {
    workflowsStartFetch: "workflowsStartFetch",
    workflowsStopFetch: "workflowsStopFetch",
    workflowsCommitFetch: "FETCH_ONBOARDING_PERSON_DATA",
    workflowsCommitUpdate: "UPDATE_ONBOARDING_PERSON_DATA",
    workflowsUpdateDocs: "workflowsUpdateDocs",
    verificationRequestsStartFetch: "verificationRequestsStartFetch",
    toggleDocumentPreviewer: "TOGGLE_DOCUMENT_PREVIEWER"
}

export interface IPersonOnboardingWorkflowState {
    loading: boolean
    workflow?: IApplicationDetails
    verificationRequests?: []
    documents?: []
    openDocumentPreviewer?: boolean
}

const initialState: IPersonOnboardingWorkflowState = {
    workflow: undefined,
    verificationRequests: undefined,
    loading: false,
    documents: [],
    openDocumentPreviewer: false,
}

export default function reducer(state = initialState, action: any) {
    switch (action.type) {

        case PersonOnboardingWorkflowConstants.verificationRequestsStartFetch: {
            return {...state, verificationRequests: action.payload}
        }

        case PersonOnboardingWorkflowConstants.workflowsStartFetch: {
            return {...state, loading: true}
        }
        case PersonOnboardingWorkflowConstants.workflowsStopFetch: {
            return {...state, loading: false}
        }

        case PersonOnboardingWorkflowConstants.workflowsCommitFetch: {
            const workflow: IApplicationDetails = action.payload
            return {...state, workflow, loading: true}
        }

        case PersonOnboardingWorkflowConstants.workflowsCommitUpdate: {
            const workflow: IApplicationDetails = action.payload
            return {...state, workflow, loading: true}
        }

        case PersonOnboardingWorkflowConstants.workflowsUpdateDocs: {
            return {...state, documents: action.payload}
        }

        case PersonOnboardingWorkflowConstants.toggleDocumentPreviewer: {
            return {...state, openDocumentPreviewer: action.payload}
        }

        default: {
            return state
        }
    }
}


export function updateWorkflowDocs(document: IDocument) {
    return {
        type: PersonOnboardingWorkflowConstants.workflowsUpdateDocs,
        payload: document
    }
}

export function startWorkflowFetch() {
    return {type: PersonOnboardingWorkflowConstants.workflowsStartFetch}
}

// export function fetchWorkflowAsync(caseId: string) {
//     const url = `${remoteRoutes.workflows}/${caseId}`
//     return (dispatch: Dispatch<any>) => {
//         get(
//             url,
//             resp => dispatch({type: workflowConstants.workflowsCommitFetch, payload: resp}),
//             undefined,
//             () => dispatch({type: workflowConstants.workflowsStopFetch})
//         )
//     };
// }
